import { render, staticRenderFns } from "./CreatePrestationAdditionnelle.vue?vue&type=template&id=0980a972&"
import script from "./CreatePrestationAdditionnelle.vue?vue&type=script&lang=ts&"
export * from "./CreatePrestationAdditionnelle.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePrestationAdditionnelle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports